"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("./constants");

var service_error_classification_1 = require("@aws-sdk/service-error-classification");

exports.defaultRetryDecider = function (error) {
  if (!error) {
    return false;
  }

  if (error.connectionError) {
    return true;
  }

  if (hasMetadata(error) && error.$metadata.httpStatusCode && constants_1.RETRYABLE_STATUS_CODES.has(error.$metadata.httpStatusCode)) {
    return true;
  }

  return service_error_classification_1.isStillProcessingError(error) || service_error_classification_1.isThrottlingError(error) || service_error_classification_1.isClockSkewError(error);
};

function hasMetadata(error) {
  return error === null || error === void 0 ? void 0 : error.$metadata;
}